<template>
  <div>
    <list
      v-loading="IsLoading"
      :row-key="WorkDocId"
      ref="list"
      unit="工单管理"
      show-checkbox
      :page="page"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      max-height="500"
      v-if="trendShow"
      :queryParamsAppend="{ Stage: Stage }"
      @check-change="checkChange"
      :temp-params="tempParams"
      urlHash="production/ticketmanagement/newworkorder/currency3"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"> </slot>
      </template>
    </list>
    <img-dialog ref="imgDialog" :imgs="imgs" />
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import VueBarcode from 'vue-barcode'
import imgDialog from './imgDialog'

export default {
  mixins: [listMixin],
  components: { list, VueBarcode, imgDialog },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  props: {
    IsDialog: {
      type: Boolean,
      default: false
    },
    Stage: {
      type: Number,
      default: 0
    },
    OrderType: {
      type: String,
      default: '未下达'
    }
  },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      WorkDocRecordApi: require('@/api/production/workDocRecord').default,
      urlHash: 'production/ticketmanagement/newworkorder/currency',
      pdApi: require('@/api/ba/product').default,
      trendShow: true,
      IsLoading: true,
      tempParams: {
        IsRelease: true
        // DailyProduction:1 // 默认日期为今天
      },
      isMB: this.$store.state.isMB,
      list: [],
      orderType: '未下达',
      imgs: []
    }
  },
  created() {},
  activated() {
    this.getRouterInfo()
  },
  watch: {
    OrderType(v) {
      this.orderType = v
    }
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getDocList(params).then(res => {
          res.Data = res.Data.map(item => {
            return {
              ...item,
              isEditBtn: false,
              isEdit: false,
              isDp: item.ProductionType == 1 ? true : false, // 车间禁用状态
              isProductionDp: item.ProductionType == 0 ? true : false //加工商禁用状态
            }
          })

          this.IsLoading = false
          resolve(res)
        })
      })
    },
    getRouterInfo() {
      if (this.$router.history.current.params) {
        this.tempParams.OrderNo = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.OrderNo
        }
        if (this.$router.history.current.params.type === '明细' && this.$router.history.current.params.DocType === '装配工单') {
          this.tempParams.WorkDocNo = {
            paramValueType: 'resetParamValue',
            isReset: true,
            value: this.$router.history.current.params.DocNo
          }
        }
        this.tempParams.ProductionType = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.ProductionType
        }
        this.tempParams.Ids = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.Ids
        }
        this.$refs.list.getData()
      }
    },
    color(row) {
      if (row.Status == 7) return 'c-lightgray'
      if (row.Status == 6) return 'c-danger'
    },
    checkChange(list) {
      this.list = list
    },
    // del() {
    //   let ids = this.list.map(item => {
    //     return item.WorkDocId;
    //   })
    //   let flag = [];
    //   this.list.forEach(item => {
    //     if (item.Status == 3) {
    //       if (!flag.includes('已审核')) {
    //         flag.push('已审核')
    //       }
    //     }
    //     if (item.Status == 4) {
    //       if (!flag.includes('生产中')) {
    //         flag.push('生产中')
    //       }
    //     }
    //     if (item.Status == 5) {
    //       if (!flag.includes('已完成')) {
    //         flag.push('已完成')
    //       }
    //     }
    //     if (item.Status == 6) {
    //       if (!flag.includes('终止通知')) {
    //         flag.push('终止通知')
    //       }
    //     }
    //     if (item.Status == 7) {
    //       if (!flag.includes('终止完成')) {
    //         flag.push('终止完成')
    //       }
    //     }
    //   })
    //   if (flag.length > 0) {
    //     this.$message.warning(`勾选的单据包含${flag.join(',')}内容`)
    //     return;
    //   }
    //   this.$confirm("确认删除所选的数据吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   }).then(() => {
    //     this.api.delete({ ids }).then((res) => {
    //       if (res.Code == 0) {
    //         this.$message.success("删除成功");
    //         this.reload();
    //       } else {
    //         this.$message.error(res.Msg);
    //       }
    //     });
    //   })

    // },
    /** 工单中止 */
    close() {
      let ids = this.list.map(item => {
        return item.WorkDocId
      })
      this.$confirm('确认中止所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.newClose(ids).then(res => {
          if (res.Code == 0) {
            this.$message.success('中止成功')
            this.reload()
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    /** 暂停 */
    stop(row) {
      const params = {
        WorkDocId: row.WorkDocId,
        WorkType: row.Status == 8 ? 0 : 1 /** 若挂起 就开工*/
      }

      this.$confirm('确认暂停/恢复吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.WorkDocRecordApi.submit(params).then(res => {
          if (res.Code == 0) {
            this.$message.success('操作成功')
            this.reload()
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /** 获取产品图片 */
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    }
  }
}
</script>